import { useContext, useState } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import { Button, Box, Grid, Typography } from '@mui/material'

const OnboardingTSP = ({ isTodo = false }) => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const [usePercent, setUsePercent] = useState(true)

  const dollarsToPercent = (amount, salary) => {
    return salary ? ((amount * 26) / salary) * 100 : 0
  }
  const percentToDollars = (percent, salary) => {
    return salary ? (salary / 26) * (percent / 100) : 0
  }

  const renderContributionFields = (idPrefix, labelPrefix) => {
    const contributionKey = `${idPrefix}Contribution`
    const contributionAmountKey = `${idPrefix}ContributionAmount`
    const balanceKey = `${idPrefix}Balance`

    return (
      <>
        <Grid item xs={12} mt={2} mb={2}>
          <Typography variant="body1Medium">{labelPrefix} TSP</Typography>
        </Grid>
        <Grid item xs={12}>
          {renderMuiFormField({
            id: balanceKey,
            label: `Current ${labelPrefix} TSP Balance`,
            enableHelpText: true,
            helpText: `What is your current ${labelPrefix} TSP balance?`,
            placeholder: '$250,000.00',
            inputType: 'currencyFloat',
            value: intakeState[balanceKey],
            onChange: (val) => updateIntakeStateAtKey({ [balanceKey]: val }),
          })}
        </Grid>
        {/* <Grid item xs={12} mt={2} mb={2}>
          <Typography variant="body1Medium">
            {labelPrefix} Contribution Amount
          </Typography>
        </Grid> */}

        {usePercent ? (
          <>
            <Grid item xs={12} mt={2}>
              {renderMuiFormField({
                id: contributionKey,
                label: 'Contribution Percent',
                enableHelpText: true,
                helpText: `What percentage do you contribute to your ${labelPrefix} TSP?`,
                placeholder: 'Ex. 5.0%',
                inputType: 'percentage',
                value: intakeState[contributionKey],
                onChange: (val) =>
                  updateIntakeStateAtKey({
                    [contributionKey]: val,
                    [contributionAmountKey]: percentToDollars(
                      val,
                      intakeState.baseSalary
                    ),
                  }),
              })}
            </Grid>
            <Grid item xs={12} mb={2}>
              <Box display="flex" justifyContent="flex-start">
                <Button
                  variant="text"
                  color="info"
                  onClick={() => setUsePercent(false)}
                >
                  Use amount contributed per pay period instead
                </Button>
              </Box>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              {renderMuiFormField({
                id: contributionAmountKey,
                label: 'Contribution per pay period',
                enableHelpText: true,
                helpText: `What dollar amount do you contribute per pay period to your ${labelPrefix} TSP?`,
                placeholder: '$135.00',
                inputType: 'currencyFloat',
                value: intakeState[contributionAmountKey],
                onChange: (val) =>
                  updateIntakeStateAtKey({
                    [contributionAmountKey]: val,
                    [contributionKey]: dollarsToPercent(
                      val,
                      intakeState.baseSalary
                    ),
                  }),
              })}
            </Grid>
            <Grid item xs={12} mb={2}>
              <Box display="flex" justifyContent="flex-start">
                <Button
                  variant="text"
                  color="info"
                  onClick={() => setUsePercent(true)}
                >
                  Use percentage contributed per pay period instead
                </Button>
              </Box>
            </Grid>
          </>
        )}
      </>
    )
  }

  return (
    <Box sx={{ textAlign: 'left' }}>
      {!isTodo && (
        <Box mb={1}>
          <Typography variant="subtitle1" fontSize={{ xs: '16px', sm: '20px' }}>
            Let’s capture your TSP contribution details:
          </Typography>
        </Box>
      )}

      <Box component="form" py={!isTodo ? 3 : 0}>
        <Grid container columnSpacing={1}>
          {intakeState.tsp && renderContributionFields('tsp', 'Traditional')}
          {intakeState.tspRoth && renderContributionFields('tspRoth', 'Roth')}
        </Grid>
      </Box>
    </Box>
  )
}

export default OnboardingTSP
